window.addEventListener('load', () => {
	const cookieSettingsLink = document.querySelector(
		'.copyright a[href*="cookie-instellingen"], .copyright a[href*="cookie-settings"]'
	);

	if (cookieSettingsLink) {
		cookieSettingsLink.addEventListener('click', (e) => {
			e.preventDefault();

			Praivacy.showSettings();

			return false;
		});
	}
});